<!--
  Wiederverwendbares Anfrageformular mit den Feldern:
  Personenanzahl, Vor-/Nachname, E-Mail, Telefon, Skireiseziel/Land.
  Mit `detailed` (Gruppenreisen) stattdessen Zielland und Ort getrennt,
  zusätzlich Terminwunsch und Notiz.

  Wird von den Seiten "Gruppenreisen" und "Zukünftige Reiseziele" genutzt.
  Der Versand erfolgt an die per `postRoute` übergebene Route (gleiche
  Mail-Pipeline wie die bestehende Anfrage).
-->
<template>
  <div>
    <div v-if="form.feedback.show" class="text-center">
      <div class="alert alert-success" role="alert">
        {{ form.feedback.message }}
      </div>
    </div>
    <form v-if="form.show" @submit.prevent="submit()">
      <div class="row">
        <div class="col-sm-6">
          <div
            class="form-floating mb-3"
            :class="{ 'is-invalid': form.errors.personenanzahl }"
          >
            <input
              type="number"
              min="1"
              v-model="form.personenanzahl"
              class="form-control rounded-0"
              :class="{ 'is-invalid': form.errors.personenanzahl }"
              id="sif-personenanzahl"
              placeholder="Personenanzahl"
            />
            <label for="sif-personenanzahl">Personenanzahl*</label>
          </div>
          <div class="invalid-feedback" v-if="form.errors.personenanzahl">
            {{ form.errors.personenanzahl }}
          </div>
        </div>
        <div v-if="!detailed" class="col-sm-6">
          <div
            class="form-floating mb-3"
            :class="{ 'is-invalid': form.errors.reiseziel }"
          >
            <input
              type="text"
              v-model="form.reiseziel"
              class="form-control rounded-0"
              :class="{ 'is-invalid': form.errors.reiseziel }"
              id="sif-reiseziel"
              placeholder="Skireiseziel / Land"
            />
            <label for="sif-reiseziel">Skireiseziel / Land*</label>
          </div>
          <div class="invalid-feedback" v-if="form.errors.reiseziel">
            {{ form.errors.reiseziel }}
          </div>
        </div>
        <div v-else class="col-sm-6">
          <div
            class="form-floating mb-3"
            :class="{ 'is-invalid': form.errors.terminwunsch }"
          >
            <input
              type="text"
              v-model="form.terminwunsch"
              class="form-control rounded-0"
              :class="{ 'is-invalid': form.errors.terminwunsch }"
              id="sif-terminwunsch"
              placeholder="Terminwunsch"
            />
            <label for="sif-terminwunsch">Terminwunsch</label>
          </div>
          <div class="invalid-feedback" v-if="form.errors.terminwunsch">
            {{ form.errors.terminwunsch }}
          </div>
        </div>
      </div>

      <div v-if="detailed" class="row">
        <div class="col-sm-6">
          <div
            class="form-floating mb-3"
            :class="{ 'is-invalid': form.errors.zielland }"
          >
            <input
              type="text"
              v-model="form.zielland"
              class="form-control rounded-0"
              :class="{ 'is-invalid': form.errors.zielland }"
              id="sif-zielland"
              placeholder="Zielland"
            />
            <label for="sif-zielland">Zielland*</label>
          </div>
          <div class="invalid-feedback" v-if="form.errors.zielland">
            {{ form.errors.zielland }}
          </div>
        </div>
        <div class="col-sm-6">
          <div
            class="form-floating mb-3"
            :class="{ 'is-invalid': form.errors.ort }"
          >
            <input
              type="text"
              v-model="form.ort"
              class="form-control rounded-0"
              :class="{ 'is-invalid': form.errors.ort }"
              id="sif-ort"
              placeholder="Ort / Skigebiet"
            />
            <label for="sif-ort">Ort / Skigebiet</label>
          </div>
          <div class="invalid-feedback" v-if="form.errors.ort">
            {{ form.errors.ort }}
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-sm-6">
          <div
            class="form-floating mb-3"
            :class="{ 'is-invalid': form.errors.vorname }"
          >
            <input
              type="text"
              v-model="form.vorname"
              class="form-control rounded-0"
              :class="{ 'is-invalid': form.errors.vorname }"
              id="sif-vorname"
              placeholder="Vorname"
            />
            <label for="sif-vorname">Vorname*</label>
          </div>
          <div class="invalid-feedback" v-if="form.errors.vorname">
            {{ form.errors.vorname }}
          </div>
        </div>
        <div class="col-sm-6">
          <div
            class="form-floating mb-3"
            :class="{ 'is-invalid': form.errors.nachname }"
          >
            <input
              type="text"
              v-model="form.nachname"
              class="form-control rounded-0"
              :class="{ 'is-invalid': form.errors.nachname }"
              id="sif-nachname"
              placeholder="Nachname"
            />
            <label for="sif-nachname">Nachname*</label>
          </div>
          <div class="invalid-feedback" v-if="form.errors.nachname">
            {{ form.errors.nachname }}
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-sm-6">
          <div
            class="form-floating mb-3"
            :class="{ 'is-invalid': form.errors.email }"
          >
            <input
              type="email"
              v-model="form.email"
              class="form-control rounded-0"
              :class="{ 'is-invalid': form.errors.email }"
              id="sif-email"
              placeholder="E-Mail"
            />
            <label for="sif-email">E-Mail*</label>
          </div>
          <div class="invalid-feedback" v-if="form.errors.email">
            {{ form.errors.email }}
          </div>
        </div>
        <div class="col-sm-6">
          <div
            class="form-floating mb-3"
            :class="{ 'is-invalid': form.errors.telefon }"
          >
            <input
              type="text"
              v-model="form.telefon"
              class="form-control rounded-0"
              :class="{ 'is-invalid': form.errors.telefon }"
              id="sif-telefon"
              placeholder="Telefon"
            />
            <label for="sif-telefon">Telefon</label>
          </div>
          <div class="invalid-feedback" v-if="form.errors.telefon">
            {{ form.errors.telefon }}
          </div>
        </div>
      </div>

      <div v-if="detailed" class="row">
        <div class="col-12">
          <div
            class="form-floating mb-3"
            :class="{ 'is-invalid': form.errors.notiz }"
          >
            <textarea
              v-model="form.notiz"
              class="form-control rounded-0"
              :class="{ 'is-invalid': form.errors.notiz }"
              placeholder="Notiz"
              id="sif-notiz"
              style="height: 150px"
            ></textarea>
            <label for="sif-notiz">Notiz</label>
          </div>
          <div class="invalid-feedback" v-if="form.errors.notiz">
            {{ form.errors.notiz }}
          </div>
        </div>
      </div>

      <div class="py-4">
        <hr />
      </div>

      <div class="row">
        <div class="col-12">
          <div class="form-check">
            <input
              v-model="form.datenschutz"
              class="form-check-input rounded-0"
              :class="{ 'is-invalid': form.errors.datenschutz }"
              type="checkbox"
              value=""
              id="sif-datenschutz"
            />
            <label class="form-check-label" for="sif-datenschutz">
              <small
                >Ich stimme zu, dass die Angaben in dem Anfrageformular inklusive
                der dort angegebenen Kontaktdaten zwecks Bearbeitung der Anfrage
                und für den Fall von Anschlussfragen bei uns gespeichert werden.
                Diese Daten geben wir nicht ohne Ihre Einwilligung weiter.</small
              >
            </label>
            <div class="invalid-feedback" v-if="form.errors.datenschutz">
              {{ form.errors.datenschutz }}
            </div>
          </div>
          <button
            type="submit"
            class="mt-4 btn btn-primary rounded-pill"
            :disabled="form.processing"
          >
            <i class="far fa-paper-plane"></i> Anfrage senden
          </button>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import { useForm } from "@inertiajs/inertia-vue3";

export default {
  props: {
    // Name der Inertia-/Ziggy-Route, an die die Anfrage gesendet wird.
    postRoute: {
      type: String,
      required: true,
    },
    successMessage: {
      type: String,
      default: "Deine Anfrage wurde versendet, vielen Dank!",
    },
    // Zusätzliche Felder für Gruppenreisen: Terminwunsch, Zielland/Ort getrennt, Notiz.
    detailed: {
      type: Boolean,
      default: false,
    },
  },
  setup(props) {
    const form = useForm({
      show: true,
      personenanzahl: null,
      vorname: null,
      nachname: null,
      email: null,
      telefon: null,
      reiseziel: null,
      terminwunsch: null,
      zielland: null,
      ort: null,
      notiz: null,
      datenschutz: null,
      feedback: {
        show: false,
        message: "",
      },
    });

    const submit = () => {
      form.post(route(props.postRoute), {
        onStart: () => {
          form.feedback = { show: false, message: "" };
        },
        onSuccess: () => {
          form.reset();
          form.show = false;
          form.feedback = {
            show: true,
            message: props.successMessage,
          };
        },
        onError: () => {
          form.feedback = {
            show: false,
            message: "Deine Anfrage konnte nicht versendet werden.",
          };
        },
      });
    };

    return { form, submit };
  },
};
</script>
